import { render, staticRenderFns } from "./DispensaryProductCreatePro.vue?vue&type=template&id=ef8235f8&scoped=true&"
import script from "./DispensaryProductCreatePro.vue?vue&type=script&lang=js&"
export * from "./DispensaryProductCreatePro.vue?vue&type=script&lang=js&"
import style0 from "./DispensaryProductCreatePro.vue?vue&type=style&index=0&id=ef8235f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8235f8",
  null
  
)

export default component.exports